export default "__VITE_ASSET__c46e1019__"